export default __webpack_public_path__ + "static/media/00.f07fec60.jpg";